require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2005-03-30-bucket-brigades-are-beautiful.json") })
        }
      }, "path---articles-2005-03-30-bucket-brigades-are-beautiful");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2005-03-30-bucket-brigades-are-beautiful!./.cache/json/articles-2005-03-30-bucket-brigades-are-beautiful.json
// module id = 390
// module chunks = 231608221292675